<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 17 17"
  ><g><g><g><g><path
    :fill="color"
    d="M11.222 5.642c.351.351.632.772.843 1.193.772 1.615.526 3.65-.843 4.984L7.467 15.61c-1.72 1.72-4.493 1.72-6.177 0-1.72-1.72-1.72-4.493 0-6.177l2.667-2.668a4.976 4.976 0 0 0 .105 3.194L2.94 11.082c-.772.773-.772 2.071 0 2.879.807.807 2.071.807 2.878 0l3.756-3.756c.386-.386.596-.913.596-1.44 0-.526-.21-1.052-.596-1.438a2.048 2.048 0 0 0-1.44-.597l1.896-1.895c.421.175.807.456 1.193.807z"
  /></g><g><path
    :fill="color"
    d="M5.607 11.258a4.612 4.612 0 0 1-.843-1.193c-.772-1.615-.526-3.65.843-4.984L9.362 1.29c1.72-1.72 4.493-1.72 6.178 0 1.72 1.72 1.72 4.493 0 6.177l-2.668 2.668a4.976 4.976 0 0 0-.105-3.194l1.123-1.123c.772-.773.772-2.071 0-2.879a2.013 2.013 0 0 0-2.878 0L7.292 6.73a2.048 2.048 0 0 0-.597 1.44c0 .526.21 1.052.596 1.438.386.386.913.597 1.44.597L6.834 12.1c-.456-.21-.842-.491-1.228-.842z"
  /></g></g></g></g></svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#F6F5F8',
    },
    size: {
      type: Number,
      default: 21,
    },
  },
};
</script>
